// A form field value can be deep nested, and we would like to extract the first appereance of an error
export const getError = (obj: Record<any, any>) => {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      const result = getError(obj[key]);
      if (result) {
        return result;
      }
    } else if (key === 'message') {
      return obj;
    }
  }
  return null;
};
